import axios from "axios";

const backend_api = process.env.REACT_APP_BACKEND_URL;

// "Үгүй" гэсэн хэрэглэгчээс дахин асуухгүй байх хугацаа
const OFFER_SNOOZE_DAYS = 30;
const DAY_MS = 24 * 60 * 60 * 1000;

/* amsys дээрх хэрэглэгчийн автомат төлөлтийн бичлэг. Бичлэггүй бол
   amsys `{ message: "UserNotFound" }` буцаадаг — энэ үед null. */
export async function fetchAutoPayment(userId, accessToken) {
  if (!userId) return null;
  const resp = await axios.get(`${backend_api}/auto-payment?userid=${userId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const result = resp.data && resp.data.result;
  return result && result.tgUserId ? result : null;
}

export function setAutoPaymentAccepted(userId, accepted, accessToken) {
  return axios.post(
    `${backend_api}/auto-payment/accepted`,
    { tgUserId: String(userId), accepted },
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );
}

/* Карт холбосон эсэх. Сервер QPay зэрэг БҮХ худалдан авалтын дараа
   бичлэг үүсгэдэг тул бичлэг байгаа нь карт холбосон гэсэн үг биш —
   картын дугаар зөвхөн картын token (eToken) ирсэн үед хадгалагддаг. */
export function hasLinkedCard(record) {
  return !!(record && record.cardNumber && String(record.cardNumber).trim());
}

// Карт холбосон ч автомат сунгалт идэвхгүй — идэвхжүүлэхийг санал болгох хэрэглэгч
export function shouldOfferAutoRenew(record, userId) {
  return hasLinkedCard(record) && record.accepted !== true && !isOfferSnoozed(userId);
}

const snoozeKey = (userId) => `autoRenewOfferDeclined:${userId}`;

function isOfferSnoozed(userId) {
  try {
    const at = Number(window.localStorage.getItem(snoozeKey(userId)));
    return !!at && Date.now() - at < OFFER_SNOOZE_DAYS * DAY_MS;
  } catch (e) {
    return false;
  }
}

export function snoozeOffer(userId) {
  try {
    window.localStorage.setItem(snoozeKey(userId), String(Date.now()));
  } catch (e) {
    // localStorage хаалттай — дараа дахин асууна
  }
}
